// @ts-strict-ignore
import * as React from 'react';

import {MetricType} from 'common/query-builder/query-block/constants';
import {ChartType, FUNNELS_MATH_TYPES, ValueRepresentationType} from 'common/report/constants';
import {AnalysisType, ChartPlotStyle} from 'common/report/insights/util/types';
import {FunnelOrder} from 'common/report/funnels/models/constants';

import {CardSnabbdom} from '../chart-card';

const STEP_SERIES = [
  {
    count: 44662,
    avg_time: null,
    avg_time_from_start: null,
    overall_conv_ratio: 1,
    step_conv_ratio: 1,
    property_sum: null,
  },
  {
    count: 21219,
    avg_time: 334703,
    avg_time_from_start: 334703,
    overall_conv_ratio: 0.47510187631543593,
    step_conv_ratio: 0.47510187631543593,
    property_sum: null,
  },
  {
    count: 20179,
    avg_time: 66254,
    avg_time_from_start: 396271,
    overall_conv_ratio: 0.45181586135864943,
    step_conv_ratio: 0.9509873226825015,
    property_sum: null,
  },
  {
    count: 0,
    avg_time: null,
    avg_time_from_start: null,
    overall_conv_ratio: 0,
    step_conv_ratio: 0,
    property_sum: null,
  },
];

const chartProps = (events: string[], cardTitle?: string) => ({
  cardTitle,
  chartOptions: {
    type: `funnel-steps`,
  },
  projectId: ``,

  bookmark: {
    type: `funnels`,
    dashboard: {},
    params: {
      displayOptions: {
        chartType: ChartType.FunnelSteps,
        plotStyle: ChartPlotStyle.Standard,
        analysis: AnalysisType.Linear,
        value: ValueRepresentationType.Absolute,
        funnelStepsSelectedTableColumns: null,
      },
      sorting: {},
      sections: {
        cohorts: [],
        filter: [],
        formula: [],
        group: [],
        show: [
          {
            behavior: {
              type: MetricType.Funnel,
              conversionWindowDuration: 30,
              conversionWindowUnit: `day`,
              funnelOrder: FunnelOrder.Loose,
              behaviors: events.map((ev) => ({
                type: MetricType.Event,
                name: ev,
                funnelOrder: FunnelOrder.Loose,
                filtersDeterminer: `all`,
                filters: [],
              })),
            },
            isExpanded: true,
            measurement: {
              math: FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE,
            },
          },
        ],
        time: [
          {
            dateRangeType: `in the last`,
            window: {
              unit: `day`,
              value: 30,
            },
            unit: `day`,
          },
        ],
      },
    },
    can_view: true,
  },
  chartParams: {
    computed_at: `2023-11-19T14:29:22.488119+00:00`,
    headers: [`$funnel`, `Metric`, `Step`],
    series: {
      [`${events[0]} through ${events[events.length - 1]}`]: {
        ...Object.fromEntries(
          [`property_sum`, `step_conv_ratio`, `avg_time_from_start`, `count`, `overall_conv_ratio`, `avg_time`].map(
            (key) => [
              key,
              Object.fromEntries(events.map((ev, ind) => [`${ind + 1}. ${ev}`, {all: STEP_SERIES[ind][key]}])),
            ],
          ),
        ),
      },
    },
    meta: {
      min_sampling_factor: 1,
      time_period_settings: {
        quarter_start_month: 1,
      },
      report_sections: {
        group: [],
        show: [
          {
            metric_key: `${events[0]} through ${events[events.length - 1]}`,
          },
        ],
      },
    },
  },
  dataGroups: null,
});

export const FunnelPreview = ({events, cardTitle}: {events: string[]; cardTitle?: string}) => {
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events, cardTitle)} />;
};
